module.exports = wp.tokenList;